/* Burbuja «Pregunta a Nidito» para la tienda.
   Uso en Shopify (theme.liquid, antes de </body>):
   <script src="https://pregunta-nidito.TU-SUBDOMINIO.workers.dev/widget.js" defer></script>
   Si se sirve desde otro sitio (p. ej. los assets del tema), indica dónde está el chat:
   <script src="pregunta-nidito.js" data-origen="https://pregunta-nidito.TU-SUBDOMINIO.workers.dev" defer></script> */
(function () {
  if (window.__preguntaNidito) return;
  window.__preguntaNidito = true;
  var guion = document.currentScript;
  var origen = (guion.getAttribute('data-origen') || new URL(guion.src).origin).replace(/\/+$/, '');

  var css = document.createElement('style');
  css.textContent =
    '.pn-boton{position:fixed;right:18px;bottom:var(--pn-abajo,18px);z-index:2147483000;display:flex;align-items:center;gap:8px;' +
    'padding:12px 16px 12px 12px;border:0;border-radius:999px;background:#33251E;color:#FBF7F1;cursor:pointer;' +
    'font:600 15px/1 Figtree,system-ui,sans-serif;box-shadow:0 10px 30px -10px rgba(51,37,30,.6);transition:transform .15s,bottom .25s}' +
    '.pn-boton:hover{transform:translateY(-2px)}' +
    '.pn-boton i{width:30px;height:30px;border-radius:50%;background:#F2B33D;display:grid;place-items:center}' +
    '.pn-boton svg{width:17px;height:17px;fill:#33251E}' +
    '.pn-panel{position:fixed;right:18px;bottom:calc(var(--pn-abajo,18px) + 66px);z-index:2147483001;width:380px;height:min(620px,calc(100vh - var(--pn-abajo,18px) - 92px));' +
    'border:0;border-radius:20px;background:#fff;box-shadow:0 24px 60px -20px rgba(51,37,30,.55);opacity:0;' +
    'transform:translateY(12px) scale(.98);pointer-events:none;transition:opacity .2s,transform .2s}' +
    '.pn-panel.pn-abierto{opacity:1;transform:none;pointer-events:auto}' +
    '@media (max-width:480px){.pn-panel{right:0;bottom:0;width:100%;height:100%;border-radius:0}' +
    '.pn-boton.pn-oculto{display:none}}' +
    '.pn-boton.pn-sin-cajon{display:none}';
  document.head.appendChild(css);

  var boton = document.createElement('button');
  boton.className = 'pn-boton';
  boton.type = 'button';
  boton.setAttribute('aria-label', 'Abrir el asistente de Nidito');
  boton.innerHTML = '<i><svg viewBox="0 0 24 24"><path d="M12 13.2c-2.9 0-6 2.9-6 5.6 0 1.6 1.3 2.4 2.9 2.4 1.2 0 2-.6 3.1-.6s1.9.6 3.1.6c1.6 0 2.9-.8 2.9-2.4 0-2.7-3.1-5.6-6-5.6ZM6.2 11.9c1.3-.4 1.9-2 1.4-3.6-.5-1.6-2-2.6-3.2-2.2-1.3.4-1.9 2-1.4 3.6.5 1.6 1.9 2.6 3.2 2.2Zm3.5-3.4c1.5 0 2.6-1.6 2.6-3.5S11.2 1.5 9.7 1.5 7.1 3.1 7.1 5s1.1 3.5 2.6 3.5Zm4.6 0c1.5 0 2.6-1.6 2.6-3.5s-1.1-3.5-2.6-3.5-2.6 1.6-2.6 3.5 1.1 3.5 2.6 3.5Zm5.3-2.4c-1.3-.4-2.7.6-3.2 2.2-.5 1.6.1 3.2 1.4 3.6 1.3.4 2.7-.6 3.2-2.2.5-1.6-.1-3.2-1.4-3.6Z"/></svg></i>¿Dudas? Pregunta';

  var panel = null;
  function abrir(si) {
    if (!panel) {
      panel = document.createElement('iframe');
      panel.className = 'pn-panel';
      panel.title = 'Pregunta a Nidito';
      panel.src = origen + '/?embed=1';
      document.body.appendChild(panel);
      panel.getBoundingClientRect();
    }
    panel.classList.toggle('pn-abierto', si);
    boton.classList.toggle('pn-oculto', si);
  }
  boton.addEventListener('click', function () { abrir(!(panel && panel.classList.contains('pn-abierto'))); });
  window.addEventListener('message', function (e) {
    if (e.origin === origen && e.data === 'nidito-cerrar') abrir(false);
  });
  document.body.appendChild(boton);

  // Si la tienda tiene una barra fija abajo (la de compra de Nidito), la burbuja se sube encima.
  function recolocar() {
    var abajo = 18;
    document.querySelectorAll('nd-barra.is-visible').forEach(function (b) {
      if (getComputedStyle(b).display !== 'none') abajo = Math.max(abajo, b.getBoundingClientRect().height + 12);
    });
    document.documentElement.style.setProperty('--pn-abajo', Math.round(abajo) + 'px');
  }
  // Con el carrito lateral abierto, la burbuja se esconde para no tapar el total ni el botón de pago.
  var cajon = document.querySelector('cart-drawer');
  if (cajon && window.MutationObserver) {
    new MutationObserver(function () {
      var abierto = cajon.classList.contains('active');
      boton.classList.toggle('pn-sin-cajon', abierto);
      if (abierto && panel && panel.classList.contains('pn-abierto')) abrir(false);
    }).observe(cajon, { attributes: true, attributeFilter: ['class'] });
  }

  var barras = document.querySelectorAll('nd-barra');
  if (barras.length && window.MutationObserver) {
    var mo = new MutationObserver(recolocar);
    barras.forEach(function (b) { mo.observe(b, { attributes: true, attributeFilter: ['class'] }); });
    window.addEventListener('resize', recolocar);
    recolocar();
  }
})();
